import { ThemeKeys } from '@view/login/themes/themeData'

export type navLinksType = null | { title: string; icon: string; link: string }[]

export type Themes = ['fod', 'fleetoperations', 'traxall', 'fod-sui', 'compello', 'rac', 'gts']

export type ThemeTypes = Themes[number]
export interface InitialStateType {
	addressesSearchLoading: boolean
	peekClassName: string
	modalOpen: boolean
	pageTitle: string
	footerVisible: boolean
	isFluid: boolean
	navOpen: boolean
	mapPeekOpen: boolean
	mapPeekContent: null | (() => JSX.Element)
	peekOpen: boolean
	peekContent: null | (() => JSX.Element)
	responsivePeek: boolean
	hoveredListVehicle: null | string
	theme: ThemeKeys
}

export type SetHoveredListVehicleAction = {
	type: 'SET_HOVERED_LIST_VEHICLE'
	payload: string
}

export type SetResponsivePeekAction = {
	type: 'SET_RESPONSIVE_PEEK'
	payload: boolean
}

export type SetPeekClassNameAction = {
	type: 'SET_PEEK_CLASSNAME'
	payload: string
}

export type SetAddressSearchLoadingAction = {
	type: 'SET_ADDRESSES_SEARCH_LOADING'
	payload: boolean
}

export type DisplayFooterAction = {
	type: 'DISPLAY_FOOTER'
	payload: boolean
}

export type ToggleModalViewAction = {
	type: 'TOGGLE_MODAL'
	payload: boolean
}

export type SetNavOpenAction = {
	type: 'SET_NAV_OPEN'
	payload: boolean
}

export type SetMapPeekOpenAction = {
	type: 'SET_MAP_PEEK_OPEN'
	payload: boolean
}

export type SetMapPeekContentAction = {
	type: 'SET_MAP_PEEK_CONTENT'
	payload: () => JSX.Element
}

export type SetPeekOpenAction = {
	type: 'SET_PEEK_OPEN'
	payload: boolean
}

export type SetPeekContentAction = {
	type: 'SET_PEEK_CONTENT'
	payload: () => JSX.Element
}
export type SetPageTitle = {
	type: 'SET_PAGE_TITLE'
	payload: string
}

export type SetTheme = {
	type: 'SET_THEME'
	payload: ThemeTypes
}

export type UiContextDispatchActions =
	| SetHoveredListVehicleAction
	| SetResponsivePeekAction
	| SetPeekClassNameAction
	| SetAddressSearchLoadingAction
	| DisplayFooterAction
	| ToggleModalViewAction
	| SetNavOpenAction
	| SetMapPeekOpenAction
	| SetMapPeekContentAction
	| SetPeekOpenAction
	| SetPeekContentAction
	| SetPageTitle
	| SetTheme
